import { FormCheckbox, FormDate, FormInput, FormSelect } from '@myxplor/forms'
import React from 'react'
import Grid from '../../../ui/grid'
import './accs.css'

const options = [
  { value: 'CODE01', label: 'Parenting Assist, Family Support Program' },
  { value: 'CODE02', label: 'Conflict/Separation/Mediation services' },
  { value: 'CODE03', label: 'Child and Maternal Health Services' },
  { value: 'CODE04', label: 'Drug/Substance Abuse Services' },
  { value: 'CODE05', label: 'Community Health Services' },
  { value: 'CODE06', label: 'Domestic Violence/Rape Victim Support' },
  { value: 'CODE07', label: 'Homelessness, Crisis or Public Housing' },
  { value: 'CODE08', label: 'Financial/Gambling Counselling Services' },
  { value: 'CODE09', label: 'Aboriginal Torres Strait Services' },
  { value: 'CODE10', label: 'School Education Related Services' },
  { value: 'CODE11', label: 'Other Early Intervention Services' },
  { value: 'CODE12', label: 'Child Protection Agency' },
]

const StateDetails = ({
  readOnly,
  values,
  onChange,
  isDetermination,
  showNumber = true,
}) => {
  const notify3rdParty = values.state_details.notified_third_party
  const thirdPartyNotifiedMe = values.state_details.third_party_notified_me

  return (
    <fieldset>
      <legend>
        {showNumber ? '5.' : null} State or Territory Details{' '}
        {!isDetermination && values.weeks_at_risk > 4 ? '' : '(Optional)'}
      </legend>
      While state or territory details are optional, you will need to update the
      certificate with these details before the certificate ends.
      <FormDate
        disabled={readOnly}
        name="state_details.date_of_notice"
        label="Date of notice"
        onChange={onChange}
        value={values.state_details.date_of_notice}
        required={isDetermination || (!isDetermination && values.weeks_at_risk > 4)}
        today
      />
      <Grid>
        <FormInput
          htmlInput={{ readOnly: readOnly }}
          required={isDetermination || notify3rdParty}
          label="Organisation Name"
          name="state_details.org_name"
          value={values.state_details.org_name}
          type="text"
          maxLength={255}
          autoFocus={false}
          onChange={onChange}
          loading={false}
        />
        <FormSelect
          htmlSelect={{ defaultValue: 'CODE01', disabled: readOnly }}
          label="Body Type"
          name="state_details.body_type"
          value={values.state_details.body_type}
          onChange={onChange}
          placeholder="Please select ..."
          options={options}
          required={isDetermination}
        />
      </Grid>
      <FormInput
        htmlInput={{ readOnly: readOnly }}
        label="Reference Number"
        name="state_details.ref_number"
        value={values.state_details.ref_number}
        maxLength={20}
        type="text"
        autoFocus={false}
        onChange={onChange}
        loading={false}
      />
      <FormInput
        htmlInput={{ readOnly: readOnly }}
        label="State Person Name & ID"
        maxLength={40}
        name="state_details.person_id"
        value={values.state_details.person_id}
        type="text"
        autoFocus={false}
        onChange={onChange}
        loading={false}
      />
      <Grid>
        <FormInput
          htmlInput={{ readOnly: readOnly }}
          label="Phone Number"
          name="state_details.person_phone"
          value={values.state_details.person_phone}
          type="text"
          maxLength={30}
          autoFocus={false}
          onChange={onChange}
          loading={false}
        />
        <FormInput
          htmlInput={{ readOnly: readOnly }}
          label="Email"
          name="state_details.person_email"
          maxLength={255}
          value={values.state_details.person_email}
          type="text"
          autoFocus={false}
          onChange={onChange}
          loading={false}
        />
      </Grid>
      <div id="thirdPartyNotification">
        Were you notified by a third party or will you be notifying a third
        party? A third party might include government agencies.
      </div>
      <br />
      <Grid>
        <FormCheckbox
          label={'Third party notified me.'}
          name={'state_details.third_party_notified_me'}
          value={thirdPartyNotifiedMe}
          onChange={notify3rdParty ? () => {} : onChange}
          loading={notify3rdParty}
          compact
        />
        <FormCheckbox
          label={'Notified third party.'}
          name={'state_details.notified_third_party'}
          value={notify3rdParty}
          onChange={thirdPartyNotifiedMe ? () => {} : onChange}
          loading={thirdPartyNotifiedMe}
          compact
        />
      </Grid>
    </fieldset>
  )
}

export default StateDetails



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/state-details.js